module.exports = __webpack_public_path__ + "b2fb7cd72553f09c3d9030e9a66f1db4.MP3";